export const mapsApiKey = "AIzaSyB1P0lBgfwy5_IUZGWlLPCJamHLy5QBDVc"
export const firebaseApiKey = "AIzaSyB1P0lBgfwy5_IUZGWlLPCJamHLy5QBDVc"